var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',{attrs:{"breadcrumbs":_vm.breadcrumbs}},[_c('view-skeleton',[_c('profile')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }